import React from 'react';
import PropTypes from 'prop-types';
import { getSkeletonRows } from './helper';
import { Skeleton } from '../../Skeleton';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import { ListSelectionTypes } from '../helper';
import { ListActions } from '../ListActions';
import { ListDataCard } from '../ListDataCard';
import { ListItem } from '../ListItem';
import { ListItemGroup } from '../ListItemGroup';
import { ListMidSection } from '../ListMidSection';
import { ListMoreActions } from '../ListMoreActions';
import { ListTitle } from '../ListTitle';
import { ListTitleBlock } from '../ListTitleBlock';
const ListSkeleton = _ref => {
  let {
    listSelectionType,
    skeletonRows,
    titleBlockProps
  } = _ref;
  const {
    isMobile: isMobileView
  } = useIsMobile(640);
  const {
    isMobile: isTabletView
  } = useIsMobile(1024);
  return /*#__PURE__*/React.createElement(ListItemGroup, null, getSkeletonRows(skeletonRows).map(element => {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: element,
      selectionIdentifier: '',
      isLoading: true
    }, listSelectionType !== ListSelectionTypes.DEFAULT ? /*#__PURE__*/React.createElement(Skeleton, {
      width: '16px',
      height: '16px'
    }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(ListDataCard, null, /*#__PURE__*/React.createElement(ListTitleBlock, {
      isLoading: true
    }, !isTabletView && !isMobileView && titleBlockProps?.thumbnail && /*#__PURE__*/React.createElement("div", {
      style: {
        marginRight: '1rem'
      }
    }, /*#__PURE__*/React.createElement(Skeleton, {
      width: '7.5rem',
      height: '4.5rem'
    })), /*#__PURE__*/React.createElement(ListTitle, {
      isLoading: true,
      style: {
        gap: '0.5rem'
      }
    }, /*#__PURE__*/React.createElement(Skeleton, {
      width: isMobileView ? '12.5' : '15.5rem',
      height: '1.5rem'
    }), /*#__PURE__*/React.createElement(Skeleton, {
      width: isMobileView ? '16rem' : '27rem',
      height: '1rem'
    }), /*#__PURE__*/React.createElement(Skeleton, {
      width: isMobileView ? '16rem' : '27rem',
      height: '1rem'
    }))), /*#__PURE__*/React.createElement(ListMidSection, {
      isLoading: true,
      style: isMobileView ? {
        marginRight: 0,
        marginLeft: 'auto'
      } : {}
    }), /*#__PURE__*/React.createElement(ListActions, {
      isLoading: true
    }), /*#__PURE__*/React.createElement(ListMoreActions, {
      isLoading: true
    }, /*#__PURE__*/React.createElement(Skeleton, {
      width: '2.5rem',
      height: '2.5rem'
    }))));
  }));
};
ListSkeleton.propTypes = {
  listSelectionType: PropTypes.string.isRequired,
  skeletonRows: PropTypes.number.isRequired,
  titleBlockProps: PropTypes.object.isRequired
};
export default ListSkeleton;